class SessionSyncService {
  constructor() {
    this.storageKey = 'vortiqaUser';
    this.secondaryStorageKey = 'vortiqa:authToken';
    this.listeners = [];
    this.setupStorageListener();
  }

  // Configurar listener para mudanças no localStorage
  setupStorageListener() {
    window.addEventListener('storage', (e) => {
      if (e.key === this.storageKey || e.key === this.secondaryStorageKey) {
        this.notifyListeners(e);
      }
    });
  }

  // Adicionar listener para mudanças de sessão
  addListener(callback) {
    this.listeners.push(callback);
  }

  // Remover listener
  removeListener(callback) {
    this.listeners = this.listeners.filter(l => l !== callback);
  }

  // Notificar todos os listeners
  notifyListeners(event) {
    this.listeners.forEach(callback => callback(event));
  }

  sync(userData) {
    if (userData && userData.token) {
      const secondaryData = {
        token: userData.token,
        user: {
          id: userData.id,
          name: userData.nome,
          email: userData.email,
          profile: userData.profile,
          companyId: userData.companyId
        },
        timestamp: Date.now()
      };
      
      localStorage.setItem(this.secondaryStorageKey, JSON.stringify(secondaryData));
      
      this.setCookie('vortiqa_token', userData.token, 1);
      this.setCookie('vortiqa_user', JSON.stringify(secondaryData.user), 1);
    }
  }

  syncFromSecondary() {
    const secondaryData = localStorage.getItem(this.secondaryStorageKey);
    if (secondaryData) {
      try {
        const parsed = JSON.parse(secondaryData);
        const primaryData = {
          id: parsed.user.id,
          nome: parsed.user.name,
          email: parsed.user.email,
          profile: parsed.user.profile,
          companyId: parsed.user.companyId,
          token: parsed.token,
          timestamp: parsed.timestamp
        };
        
        localStorage.setItem(this.storageKey, JSON.stringify(primaryData));
        return primaryData;
      } catch (error) {
      }
    }
    return null;
  }

  // Limpar todas as sessões
  clearAllSessions() {
    localStorage.removeItem(this.storageKey);
    localStorage.removeItem(this.secondaryStorageKey);
    this.deleteCookie('vortiqa_token');
    this.deleteCookie('vortiqa_user');
  }

  // Verificar se há sessão ativa
  hasActiveSession() {
    const primaryData = localStorage.getItem(this.storageKey);
    const secondaryData = localStorage.getItem(this.secondaryStorageKey);
    return !!(primaryData || secondaryData);
  }

  // Obter dados da sessão atual
  getCurrentSession() {
    const primaryData = localStorage.getItem(this.storageKey);
    if (primaryData) {
      try {
        return JSON.parse(primaryData);
      } catch (error) {
      }
    }
    return null;
  }

  // Utilitários para cookies
  setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
  }

  deleteCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
  }

  generateSSOUrl(baseUrl, userData, redirectTo = 'tickets') {
    if (!userData || !userData.token) {
      throw new Error('Dados de usuário ou token não fornecidos');
    }
    
    const params = new URLSearchParams({
      token: userData.token,
      user: JSON.stringify({
        id: userData.id,
        name: userData.nome,
        email: userData.email,
        profile: userData.profile,
        companyId: userData.companyId
      }),
      sso: 'true',
      redirect: redirectTo,
      timestamp: Date.now().toString()
    });
    
    return `${baseUrl}/auth/sso?${params.toString()}`;
  }

  // Processar parâmetros de SSO da URL
  processSSOParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const userParam = urlParams.get('user');
    const sso = urlParams.get('sso');
    
    if (sso === 'true' && token && userParam) {
      try {
        const user = JSON.parse(userParam);
        const userData = {
          id: user.id,
          nome: user.name,
          email: user.email,
          profile: user.profile,
          companyId: user.companyId,
          token: token,
          timestamp: Date.now()
        };
        
        // Armazenar dados da sessão
        localStorage.setItem(this.storageKey, JSON.stringify(userData));
        this.sync(userData);
        
        // Limpar parâmetros da URL
        const newUrl = window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);
        
        return userData;
      } catch (error) {
      }
    }
    
    return null;
  }
}

// Instância singleton
const sessionSync = new SessionSyncService();

export default sessionSync;
